export async function loadFormSchemas(templateList) {
    const loadTemplatePromises = templateList.map((template) => {
        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script');
            scriptElement.src = `formSchema/${template}`;

            scriptElement.onload = () => {
                console.log(`Template loaded: ${template}`);
                resolve();
            };

            scriptElement.onerror = () => {
                console.error(`Failed to load template: ${template}`);
                resolve();
                //reject(new Error(`Failed to load ${template}`));
            };

            document.head.appendChild(scriptElement);
        });
    });

    // Wait for all templates to be loaded
    await Promise.all(loadTemplatePromises);
    console.log("All form templates loaded.");
}

